::ng-deep particle-task-header .task-title{font-size:1.8rem;font-weight:500;color:#252d44;line-height:initial}
/*# sourceMappingURL=task-header.component-N7XLA76J.css.map */
